import type { IProcessActivityReadSection } from '@common/interfaces/processActivityReadSection';
import type { BariPostSecretarialAssistantFollowUpReadData } from '@common/validation/customControls/bariPost/bariPostSecretarialAssistentFollowUp/v1/bariPostSecretarialAssistentFollowUpSchemaV1';
import { PatientPresence } from '@common/customControls/bariatrics';
import { getProcessActivityReadSectionItem } from '@common/utils/processActivityReadUtil';

export function bariPostSecretarialAssistantFollowUpReadSectionsTransformer(
    readSections: IProcessActivityReadSection[]
): IProcessActivityReadSection[] {
    const item = getProcessActivityReadSectionItem<BariPostSecretarialAssistantFollowUpReadData>()(
        readSections,
        'aanwezigheid'
    );

    if (item?.value === PatientPresence.notPresent) {
        return readSections.slice(0, 1);
    }

    return readSections;
}
